import { Route, Routes } from 'react-router-dom';
import BreederProfile from '../pages/profile/BreederProfile';
import MarketplaceCheckout from '../pages/market-place/MarketplaceCheckout';
import MarketPlacePreview from '../pages/market-place/marketPlacePreview';
import MyListing from '../pages/market-place/MyListing';
import MyOrders from '../pages/market-place/MyOrders';
import { MARKETPLACE_PATHS } from '../constants/routePaths';

const MarketPlaceRoutes = () => {
  return (
    <div>
      <Routes>
        <Route path={MARKETPLACE_PATHS.CHECKOUT} element={<MarketplaceCheckout />} />
        <Route path={MARKETPLACE_PATHS.MY_LISTING} element={<MyListing />} />
        <Route path={MARKETPLACE_PATHS.MY_ORDERS} element={<MyOrders />} />
        <Route path={MARKETPLACE_PATHS.PROFILE_ACCOUNT} element={<BreederProfile />} />
        <Route path={MARKETPLACE_PATHS.SPECIMEN} element={<MarketPlacePreview />} />
      </Routes>
    </div>
  );
};

export default MarketPlaceRoutes;
